module.exports = __webpack_public_path__ + "static/img/sharemc.802d8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sharemc.png
// module id = lBlZ
// module chunks = 1